import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2285a342&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=2285a342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285a342",
  null
  
)

export default component.exports